import loadable from '@loadable/component'

export default [
  {
    // 帮助与客服
    path: '/HelpCenter/HelpAndService',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HelpCenter-HelpAndService" */ '~/pages/HelpCenter/HelpAndService'
        )
    ),
  },
  {
    // 猜你想问
    path: '/HelpCenter/GuessYourAsk',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HelpCenter-GuessYourAsk" */ '~/pages/HelpCenter/GuessYourAsk'
        )
    ),
  },
  {
    // 问题列表
    path: '/HelpCenter/ProblemList/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HelpCenter-ProblemList" */ '~/pages/HelpCenter/ProblemList'
        )
    ),
  },
  {
    // 问题详情
    path: '/HelpCenter/ProblemDetail/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-HelpCenter-ProblemDetail" */ '~/pages/HelpCenter/ProblemDetail'
        )
    ),
  },
  {
    // 帮助中心
    path: '/Helping/Center',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Helping-Center" */ '~/pages/Helping/Center'
        )
    ),
  },
  {
    // 问题合集
    path: '/Helping/QuestionTypes',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Helping-QuestionTypes" */ '~/pages/Helping/QuestionTypes'
        )
    ),
  },
  {
    // 工单历史列表
    path: '/Helping/ReportList',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Helping-ReportList" */ '~/pages/Helping/ReportList'
        )
    ),
  },
  {
    // 工单结果反馈
    path: '/Helping/ReportResNotify',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Helping-ReportResNotify" */ '~/pages/Helping/ReportResNotify'
        )
    ),
  },
  {
    // 工单详情
    path: '/Helping/ReportDetails',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Helping-ReportDetails" */ '~/pages/Helping/ReportDetails'
        )
    ),
  },
  {
    // 问题合集
    path: '/Helping/Question/Edit',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Helping-Question-Edit" */ '~/pages/Helping/Question/Edit'
        )
    ),
  },
  {
    // 问题合集
    path: '/Helping/Question/View/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-Helping-Question-View" */ '~/pages/Helping/Question/View'
        )
    ),
  },
]
